// @flow
import Loadable from 'react-loadable'

import Loader from '@src/components/ui/ReactLoadableLoader'

const MyCompanyLoader = Loadable({
  loader: () => import('./MyCompanyContainer'),
  loading: Loader,
})

export default MyCompanyLoader
